import { rpApi } from "@/http";

type ApiGetResult = ReturnType<typeof rpApi.get>;

interface PreviewRequestOptions {
  signal?: AbortSignal;
  publicPreview?: boolean;
}

export default {
  getSimpleInfo(shelfId: string): ApiGetResult {
    return rpApi.get("/shelf-web/v1/shelf/simpleInfo", { shelfId });
  },
  getDetail(shelfId: string, options?: PreviewRequestOptions): ApiGetResult {
    return rpApi.get("/shelf-web/v1/shelf/detail", { shelfId }, options);
  },
  getStaticDetail(shelfId: string, signal?: AbortSignal): ApiGetResult {
    return rpApi.get(
      "/shelf-web/base-static-detail",
      { shelfId },
      { publicPreview: true, signal }
    );
  },
  getUniversalDetail(id: string, signal?: AbortSignal): ApiGetResult {
    return rpApi.get(
      "/shelf-web/detail-universal",
      { id },
      { publicPreview: true, signal }
    );
  },
  getSimpleList(shelfId: string, signal?: AbortSignal): ApiGetResult {
    return rpApi.get(
      "/shelf-web/simple-list",
      { "id[]": shelfId, limit: 1, offset: 0 },
      { publicPreview: true, signal }
    );
  },
};
